import "./ProStar.scss";

export function ProStar() {
  return (
    <img
      className={"pro-star"}
      alt={""}
      src={
        "https://www.musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg"
      }
    />
  );
}
